import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import TirPmNotificationMessage from "./TirPmNotificationMessage.vue";

import { PropType, onMounted, onUnmounted, ref } from "vue";
import { TirPmNotificationEventBus } from "./utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmNotificationGroup',
  props: {
  /**Уникальный идентификатор группы сообщения */
  group: { type: String, default: null },
  /** Позиция выводимого сообщения */
  position: {
    type: String as PropType<"top-left" | "top-right" | "bottom-left" | "bottom-right">,
    default: "bottom-right",
  },
  /**z-index сообщения */
  zIndex: { type: Number, default: 0 },
},
  emits: ["close", "life-end"],
  setup(__props, { emit }) {

const props = __props;


/**События компонента */


const messages = ref<any[]>([]);
const styleElement = ref<any>(null);
const $container = ref<any>(null);
const messageIdx = ref(0);

onMounted(() => {
  TirPmNotificationEventBus.on("add", onAdd);
  TirPmNotificationEventBus.on("remove-group", onRemoveGroup);
  TirPmNotificationEventBus.on("remove-all-groups", onRemoveAllGroups);
});

onUnmounted(() => {
  destroyStyle();
  TirPmNotificationEventBus.off("add", onAdd);
  TirPmNotificationEventBus.off("remove-group", onRemoveGroup);
  TirPmNotificationEventBus.off("remove-all-groups", onRemoveAllGroups);
});

const add = (message: any) => {
  if (message.id == null) message.id = messageIdx.value++;
  messages.value = [...messages.value, message];
};
const remove = (params: any) => {
  let index = -1;

  for (let i = 0; i < messages.value.length; i++) {
    if (messages.value[i] === params.message) {
      index = i;
      break;
    }
  }

  messages.value.splice(index, 1);
  emit(params.type, { message: params.message });
};
const onAdd = (message: any) => {
  if (props.group == message.group) add(message);
};
const onRemoveGroup = (group: any) => {
  if (props.group === group) messages.value = [];
};
const onRemoveAllGroups = () => (messages.value = []);
const destroyStyle = () => {
  if (!styleElement.value) return;
  document.head.removeChild(styleElement.value);
  styleElement.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "$container",
    ref: $container,
    class: ["notification-group", {
      'notification-group--top-left': props.position == 'top-left',
      'notification-group--top-right': props.position == 'top-right',
      'notification-group--bottom-left': props.position == 'bottom-left',
      'notification-group--bottom-right': props.position == 'bottom-right',
    }]
  }, _ctx.$attrs, {
    style: { 'z-index': __props.zIndex } as any
  }), [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg) => {
          return (_openBlock(), _createBlock(TirPmNotificationMessage, {
            key: msg.id,
            message: msg,
            template: _ctx.$slots.message,
            "z-index": __props.zIndex,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (remove($event)))
          }, null, 8, ["message", "template", "z-index"]))
        }), 128))
      ]),
      _: 1
    })
  ], 16))
}
}

})